module.exports = __webpack_public_path__ + "static/img/close.5910110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 9